import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpErrorResponse, HttpHeaders, HttpResponse } from '@angular/common/http';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';

import { IScopeMySuffix } from 'src/app/shared/model/scope-my-suffix.model';
import { JhiEventManager, JhiParseLinks, JhiAlertService } from 'ng-jhipster';

import { IRuleMySuffix } from 'src/app/shared/model/rule-my-suffix.model';
import { Principal } from 'src/app/core';

import { RuleMySuffixService } from 'src/app/entities/rule-my-suffix/rule-my-suffix.service';

import { ITEMS_PER_PAGE } from 'src/app/shared/constants/pagination.constants';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { LanguageChangeService } from 'src/app/shared/services/language-change.service';

@Component({
    selector: 'jhi-scope-my-suffix-detail',
    templateUrl: './open-policy-scope-my-suffix-detail.component.html'
})
export class OpenPolicyScopeMySuffixDetailComponent implements OnInit {
    @ViewChild('confirmDelete') confirmDelete: ModalDirective;

    scope: IScopeMySuffix;
    rules = [];

    routeData: any;
    links: any;
    totalItems: any;
    queryCount: any;
    itemsPerPage: any;
    page: any;
    predicate: any;
    previousPage: any;
    reverse: any;
    deleteRule: IRuleMySuffix;
    deleteRuleIndex: number;
    storageRule = [];

    isclauseDeductableCollapsed = true;
    isExtensionDeductableCollapsed = true;
    tempScope = [];

    constructor(
        private ruleService: RuleMySuffixService,
        private parseLinks: JhiParseLinks,
        private jhiAlertService: JhiAlertService,
        private principal: Principal,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private eventManager: JhiEventManager,
        private languageChangeService: LanguageChangeService,
    ) {
        this.itemsPerPage = ITEMS_PER_PAGE;
        this.routeData = this.activatedRoute.data.subscribe(data => {
            this.page = data.pagingParams.page;
            this.previousPage = data.pagingParams.page;
            this.reverse = data.pagingParams.ascending;
            this.predicate = data.pagingParams.predicate;
        });

        this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
            if (paramMap.get('size')) {
                this.itemsPerPage = paramMap.get('size')
            }
             const refresh = paramMap.get('refresh');
            if (refresh) {
                this.languageChangeService.refreshLanguage();
            }
    });
    }

    ngOnInit() {
      /*   this.activatedRoute.data.subscribe(({ scope }) => {
            this.scope = scope;
            this.rules = scope.rules;
        });
    } */

    this.activatedRoute.data.subscribe(({ scope }) => {
        this.scope = scope;
        this.rules = scope.rules;
        this.storageRule = scope.storageRules;
        this.scope.clauseDeductables = scope.clauseDeductable;
        this.scope.extensionDeductables = scope.extensionDeductable;
        this.tempScope = scope.clauseDeductable;
    });
}

    loadAll() {
        this.ruleService
            .query({
                page: this.page - 1,
                size: this.itemsPerPage,
                sort: this.sort()
            })
            .subscribe(
                (res: HttpResponse<IRuleMySuffix[]>) => this.paginateRules(res.body, res.headers),
                (res: HttpErrorResponse) => this.onError(res.message)
            );
    }

    private onError(errorMessage: string) {
        this.jhiAlertService.error(errorMessage, null, null);
    }

    private paginateRules(data: IRuleMySuffix[], headers: HttpHeaders) {
        this.links = this.parseLinks.parse(headers.get('link'));
        this.totalItems = parseInt(headers.get('X-Total-Count'), 10);
        this.queryCount = this.totalItems;
        this.rules = data;
    }

    loadPage(page: number) {
        if (page !== this.previousPage) {
            this.previousPage = page;
            this.transition();
        }
    }

    sort() {
        const result = [this.predicate + ',' + (this.reverse ? 'asc' : 'desc')];
        if (this.predicate !== 'id') {
            result.push('id');
        }
        return result;
    }

    transition() {
        this.router.navigate(['/rule-my-suffix'], {
            queryParams: {
                page: this.page,
                size: this.itemsPerPage,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }
        });
        this.loadAll();
    }

    previousState() {
        window.history.back();
    }

    removeRule(index, rule) {
        this.deleteRuleIndex = index;
        this.deleteRule = rule;
        this.confirmDelete.show();
        // this.ruleService.delete(rule.id).subscribe(response => {
        //     this.eventManager.broadcast({
        //         name: 'ruleListModification',
        //         content: 'Deleted an rule'
        //     });
        //     this.rules.splice(index, 1);
        // });
    }

    removeRuleDetails() {
        this.ruleService.delete(this.deleteRule.id).subscribe(response => {
            this.eventManager.broadcast({
                name: 'ruleListModification',
                content: 'Deleted an rule'
            });
            this.rules.splice(this.deleteRuleIndex, 1);
            this.hideConfirmDeleteModal();
        });
    }

    hideConfirmDeleteModal() {
        this.deleteRule = null;
        this.deleteRuleIndex = null;
        this.confirmDelete.hide();
    }

    clauseNamesFuncton(data) {
        console.log(data);

        var str = '';
        if (data) {
            let addComma = "";
            data.clauseExtensionList.map((element, index) => {
                if (data.clauseExtensionList.length - 1 == index) {
                    addComma = ""
                } else {
                    addComma = ","
                }
                str += (element.name + addComma)
            })
            return str;
        }
        console.log(str);

    }
}
